import FAQItem from '@/components/base/FAQItem';

const faqs = [
  {
    question: 'PG模拟器真的免费吗？',
    answer: '是的，PG模拟器完全免费。平台上所有游戏均提供免费试玩模式，无需充值即可体验完整的游戏内容。我们致力于为玩家提供优质的免费游戏体验。',
  },
  {
    question: 'pg模拟器需要下载安装吗？',
    answer: '不需要。PG模拟器是基于网页技术的在线平台，您只需通过浏览器访问pg模拟器官网入口即可开始游戏，无需下载任何客户端或插件，不占用设备存储空间。',
  },
  {
    question: 'pg模拟器手机版支持哪些设备？',
    answer: 'pg模拟器手机版支持iOS（iPhone/iPad）和Android设备。您可以通过手机浏览器直接访问，体验针对移动端优化的触控操作界面，无需额外下载App。',
  },
  {
    question: '游戏画面卡顿怎么办？',
    answer: '如果遇到画面卡顿，建议：1）检查网络连接稳定性；2）关闭其他占用带宽的程序；3）尝试降低浏览器中的画面质量设置；4）确保浏览器为最新版本。pg模拟器针对不同设备做了优化，大多数情况下都能流畅运行。',
  },
  {
    question: 'pg模拟器安全吗？个人信息会被泄露吗？',
    answer: 'pg模拟器采用SSL/TLS加密传输技术，严格遵守隐私保护法规。我们不会在未经授权的情况下收集或分享用户个人信息。平台运营合法合规，请放心使用。',
  },
  {
    question: '如何联系pg模拟器客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至support@pg-simulator.com，或拨打客服热线400-888-6666。我们的客服团队工作时间为周一至周五 9:00-18:00。',
  },
];

export default function FAQSection() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">关于PG模拟器的常见疑问，这里都有答案</p>
        </div>

        <div className="bg-background-50 rounded-xl px-5">
          {faqs.map((faq, i) => (
            <FAQItem key={i} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}